/**
 * Cliente del CRUD de `billing_config` (Fase 34).
 *
 * - GET    /admin/billing/config         → { config, updatedAt, updatedBy }
 * - PATCH  /admin/billing/config         → reemplaza la config entera
 * - GET    /admin/billing/config/audit   → historial append-only
 */
import { get, patchJsonAdmin } from './_core.js';

export interface BillingConfig {
  /** Markup en basis points (e.g. 2000 = 20%). 0 = sin margen. */
  markupBps: number;
}

export interface BillingConfigResponse {
  config: BillingConfig;
  updatedAt: string;
  updatedBy: string | null;
}

export interface BillingConfigAuditEntry {
  id: string;
  changedAt: string;
  changedByUserId: string | null;
  beforeConfig: BillingConfig | null;
  afterConfig: BillingConfig;
}

export async function fetchBillingConfig(): Promise<BillingConfigResponse> {
  const res = await get<BillingConfigResponse>(`/admin/billing/config`);
  return res.data;
}

export async function patchBillingConfig(
  config: BillingConfig,
): Promise<{ config: BillingConfig }> {
  return patchJsonAdmin<{ config: BillingConfig }>(`/admin/billing/config`, { config });
}

export async function fetchBillingConfigAudit(): Promise<{
  entries: BillingConfigAuditEntry[];
}> {
  const res = await get<{ entries: BillingConfigAuditEntry[] }>(`/admin/billing/config/audit`);
  return res.data;
}
